import type { PImage } from '../../engine/aliases'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageBackgroundStar {
  x: number
  y: number
  image: PImage
  depth: number
}

export const reset = () => {
  if (objs.length === 0) {
    for (let i = 0; i < 350; i++) {
      createStar()
    }
  }

  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    randomizeStar(c)
  }

  voyageLayers.getLayers().starfield1.sort('depth')
  // goatLayers.getLayers().starfield2.sort('depth')

  updateAll()
}

const colors = [voyageColors.yellow, 0xffffff]
const randomizeStar = (obj: IVoyageBackgroundStar) => {
  let cb = voyageCamera.get().bounds
  let x = rando.f(cb.x, cb.x + cb.w)
  let y = rando.f(cb.y, cb.y + cb.h)

  obj.x = x
  obj.y = y
  obj.image.x = x
  obj.image.y = y

  // obj.image.angle = rando.f(0, 360)
  obj.depth = rando.f(0.1, 1)
  obj.image.scale = Math.floor(obj.depth * 2)

  obj.image.depth = obj.depth
  obj.image.tint = rando.sample(colors)
  obj.image.alpha = rando.f(0.5, 1)
}

// let frame = frameInfo.fi32(8, 21, 9)
const createStar = () => {
  let image = spritesUtil.createImage(
    rando.sample([
      voyageLayers.getLayers().starfield1,
      // goatLayers.getLayers().starfield2,
    ]),
    rando.sample([
      sprites.voyTileParticlesStar2[0],
      sprites.voyTileParticlesStar3[0],
      sprites.voyTileParticlesStar[0],
      sprites.voyTileParticlesRound[1],
    ]),
  )

  let obj: IVoyageBackgroundStar = {
    image,
    x: 0,
    y: 0,
    depth: 1,
  }
  objs.push(obj)

  return obj
}

const objs: IVoyageBackgroundStar[] = []

export function updateAll() {
  let ds = common.getUpdateDeltaScaled()
  let scale = 1
  let depthScale = 0.05

  let cb = voyageCamera.get().bounds
  //let gb = voyageCamera.getGameBounds()

  // let playWidth = (ctx.mapShip.width - 1) * ctx.mapShip.tileSize
  // let playHeight = (ctx.mapShip.height - 1) * ctx.mapShip.tileSize

  //let centerXY = { x: gb.width / 2, h: gb.height / 2 }

  // let sx = stevieCam.get().cameraX // - playWidth / 2
  // let sy = stevieCam.get().cameraY // - playHeight / 2

  // let cx = playWidth / 2
  // let cy = playHeight / 2

  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]

    // c.x -= ds * c.depth * 20
    c.x += ds * c.depth * 20
    if (c.x < cb.x) {
      c.x += cb.w
    }
    if (c.x > cb.x + cb.w) {
      c.x -= cb.w
    }

    c.image.x = c.x //  + -(cx - centerXY.x) * (1 - c.depth * depthScale) * scale
    c.image.y = c.y // + -(cy - centerXY.y) * (1 - c.depth * depthScale) * scale
  }

  // let sx = stevieCam.get().cameraX
  // let sy = stevieCam.get().cameraY
  // let d = common.getUpdateDeltaScaled()
  // let scale = 0.25

  // let ctx = scene.getContext()
  // let playWidth = (ctx.mapShip.width - 1) * ctx.mapShip.tileSize

  // for (let i = 0; i < objs.length; i++) {
  //   let c = objs[i]

  //   c.x -= d * c.depth * 10
  //   if (c.x < 0) {
  //     c.x += playWidth
  //   }

  //   c.image.x = c.x + sx * (1 - c.depth) * scale
  //   c.image.y = c.y + sy * (1 - c.depth) * scale
  //   // c.image.y = c.y +
  // }

  // objs.forEach((c) => {
  //   update(c)
  // })
}
// function update(obj: IParticle) {
//   let d = common.getUpdateDeltaScaled()

//   let dx = (obj.dir.x * obj.speed * d) / 100
//   let dy = (obj.dir.y * obj.speed * d) / 100

//   obj.angle += (obj.angleSpeed * (2 * Math.PI)) / 60
//   obj.image.rotation = obj.angle
//   obj.image.x += dx
//   obj.image.y += dy
//   obj.timeLeft -= d
//   if (obj.timeLeft < 0) {
//     kill(obj)
//   }
// }
